export default "__VITE_ASSET__D$aRwDNs__"